import { useCreateCompanyFollowUpdateMutation } from '../../../../../store/Company/companyApiSlice';

const useCompanyUpdate = () => {
    const [createCompanyFollowUpdate] = useCreateCompanyFollowUpdateMutation();

    const handleUpdateCompany = async (companyID, content, token) => {
        try {
            await createCompanyFollowUpdate({
                companyID,
                content,
                token
            });
            return { success: true };
        } catch (error) {
            console.error(error);
            return { success: false, error };
        }
    };

    return handleUpdateCompany;
};

export default useCompanyUpdate;
